import { gql, useQuery } from '@apollo/client';
import {
  QueryUsers,
  QueryUsersOutput,
  UsersQueryVariables,
} from '@cnx-saas/common';
import { TENANT_USER_FRAGMENT } from '../fragments';

const GET_USERS_QUERY = gql`
  query getMyTenantUsers($query: QueryUsersInput!) {
    users: getMyTenantUsers(query: $query) {
      totalCount
      filteredCount
      itemList {
        ...User
      }
    }
  }
  ${TENANT_USER_FRAGMENT}
`;

export const useFindUsers = (query: QueryUsers = {}) =>
  useQuery<QueryUsersOutput, UsersQueryVariables>(GET_USERS_QUERY, {
    variables: { query },
    fetchPolicy: 'network-only',
  });
